import Observer from '../../../common/scripts/observer';

const observer = new Observer();

class MapFilter {
    /**
     * Базовые свойства
     * @constructor
     */
    constructor() {
        this.filterList = null;
        this.buttons = null;
        this.globalFilterState = true;
        this.checkEvent = document.createEvent('HTMLEvents');
        this.checkEvent.initEvent('change', false, true);
        this.showAllButton = null;
        this.hideAllButton = null;
    }

    /**
     * Инициализирует плагин
     * @param {Object} outerSettings - настройки из внешнего файла
     */
    init(outerSettings) {
        this.filterList = outerSettings.target;
        this.turnAll = true;
        this.activeFilter = [];
        this.buttons = Array.from(this.filterList.querySelectorAll('.j-map-filter-item'));
        this.showAllButton = outerSettings.wrapper.querySelector('.j-show-all');
        this.hideAllButton = outerSettings.wrapper.querySelector('.j-hide-all');

        this._bindEvents();
        this._subscribes();
    }

    /**
     * Навешивает обработчик клика
     */
    _bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('change', (event) => {
                // Если активны все элементы - то удаляем их
                if (this.turnAll) {
                    this.changeAll(false);
                    this.turnAll = false;
                    // Устанавливаем только что нажатый пункт активным, так как мы все пункты отключаем выше
                    button.checked = true;
                }

                const mapEvent = button.checked ? 'addFilterItem' : 'removeFilterItem';

                this.activeFilter.push(button.dataset.type);

                this._setGlobalFilterState();

                observer.publish(mapEvent, event.target.dataset.type);
                observer.publish('filterUpdated');

                observer.publish('setFilteredArray', this.activeFilter);
            });
        });

        this.showAllButton.addEventListener('click', () => {
            this.changeAll(true);
        });

        this.hideAllButton.addEventListener('click', () => {
            this.changeAll(false);
        });
    }

    _subscribes() {
        observer.subscribe('cleanArrayFilter', () => {
            this.activeFilter = [];
            this.turnAll = true;
        });
    }

    _setGlobalFilterState() {
        this.globalFilterState = this.buttons.every((button) => {
            return button.checked;
        });
    }

    changeCheckBoxState() {
        const holdGlobalFilterState = this.globalFilterState;

        this.buttons.forEach((button) => {
            if (button.checked !== holdGlobalFilterState) {
                return;
            }

            button.checked = !button.checked;
            button.dispatchEvent(this.checkEvent);
        });
    }

    changeAll(state) {
        // const mapEvent = state ? 'showAllMarkers' : 'hideAllFilteredMarkers';

        this.buttons.forEach((button) => {
            button.checked = state;
        });

        observer.publish('toggleAllMarkers', {
            filter: true,
            state
        });
        observer.publish('filterUpdated');

        // Чистим массив
        this.activeFilter = [];
        this.turnAll = state;
        observer.publish('setFilteredArray', this.activeFilter);
    }
}

export default MapFilter;
